export default __webpack_public_path__ + "static/gug-title-6d8c20b3dd0798122c8a61b0f8f33c2f.png";